<ng-container *ngIf="tour.active() && tour.step() as step">
  <!-- catches clicks so the page under the tour is not used by accident; dimmed
       here only for a step with nothing to point at -->
  <div class="aca-tour__backdrop" [class.aca-tour__backdrop--dim]="!spot()"></div>
  <div
    class="aca-tour__spot"
    *ngIf="spot() as s"
    [style.top.px]="s.top"
    [style.left.px]="s.left"
    [style.width.px]="s.width"
    [style.height.px]="s.height"
  ></div>

  <section
    #card
    class="aca-tour__card"
    [class.aca-tour__card--docked]="docked()"
    [style.top.px]="cardTop()"
    [style.left.px]="cardLeft()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="aca-tour-title"
    aria-describedby="aca-tour-body"
    tabindex="-1"
  >
    <header class="aca-tour__head">
      <span class="aca-tour__icon"
        ><mat-icon>{{ step.icon }}</mat-icon></span
      >
      <span class="aca-tour__count">{{ 'DMS.TOUR.STEP' | translate: { p0: tour.index() + 1, p1: tour.steps().length } }}</span>
      <button type="button" class="aca-tour__close" (click)="end()" [attr.aria-label]="'DMS.TOUR.SKIP' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <h2 class="aca-tour__title" id="aca-tour-title">{{ step.titleKey | translate }}</h2>
    <p class="aca-tour__body" id="aca-tour-body">{{ step.bodyKey | translate }}</p>

    <div class="aca-tour__dots" aria-hidden="true">
      <span class="aca-tour__dot" *ngFor="let s of tour.steps(); let i = index" [class.aca-tour__dot--on]="i === tour.index()"></span>
    </div>

    <footer class="aca-tour__actions">
      <button type="button" class="aca-tour__skip" (click)="end()" *ngIf="!tour.last()">{{ 'DMS.TOUR.SKIP' | translate }}</button>
      <span class="aca-tour__spacer"></span>
      <button type="button" class="aca-tour__back" (click)="back()" *ngIf="tour.index() > 0">{{ 'DMS.TOUR.BACK' | translate }}</button>
      <button type="button" class="aca-tour__next" (click)="next()">
        {{ (tour.last() ? 'DMS.TOUR.DONE' : 'DMS.TOUR.NEXT') | translate }}
      </button>
    </footer>
  </section>
</ng-container>
